import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPSData } from '../../../../../shared/models/ips-data';
import { SidebarService } from '../../../../../shared/services/sidebar.service';
import { faArrowDown, faArrowUp, faEquals, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { LatestDepth } from '../../../../../shared/models/latest-depth';
import { SensorService } from '../../../../../shared/services/sensor.service';
import { isSameDay, subMonths } from 'date-fns';
import { ChartData } from '../../../../../shared/models/depth-data';
import { catchError, map, Observable, of } from 'rxjs';
import { DecimalPipe } from '@angular/common';


@Component({
  selector: 'app-model-headband',
  templateUrl: './model-headband.component.html',
  styleUrl: './model-headband.component.scss'
})
export class ModelHeadbandComponent {
  @Input() ipsData!: IPSData;
  @Input() hasModel!: boolean;
  @Output() sidebarChange = new EventEmitter<boolean>()
  latestDepth!: LatestDepth;
  showDepthModal: boolean = false;
  showModeleModal: boolean = false;
  showSidebar: boolean = false;
  faArrowUp = faArrowUp;
  faArrowDown = faArrowDown;
  faEquals = faEquals;
  faQuestion = faQuestion;
  today: Date;
  endDate: string;
  startDate: string;
  chartData$!: Observable<ChartData>;
  showDepthDetail: boolean = false;
  showDepthChart: boolean = false;
  hasDetails: boolean = false;
  isPiezo: boolean = false;

  constructor(private sidebarService: SidebarService, private sensorService: SensorService){
    this.today = new Date();
    this.endDate = this.today.toISOString().split('T')[0]; 
    this.startDate = subMonths(this.today, 1).toISOString().split('T')[0]; 

    this.sidebarService.sidebarStatus$.subscribe((res)=> {
      this.showSidebar = res;
    });
  }

  ngOnChanges() {
    if (this.ipsData) {
      this.isPiezo = this.ipsData.type_Donnee.type === 'Piezo';
      this.sensorService.getSensorLatestDepth(this.ipsData.identifier, this.ipsData.type_Donnee.type, true).subscribe(
        {
          next: (res) => {
            this.latestDepth = res;
            if(!res){
              this.latestDepth = {
                date: "2000-01-01T00:00:00",
                value: null,
              }
            }
          },
          error :(error) => {
            console.error('Error fetching latest depth:', error);
            this.sidebarService.setSidebarStatus(false);
          }
        }
      );
  
      const params = `startDate=${this.startDate}&endDate=${this.endDate}`;
      this.chartData$ = this.sensorService.getSensorDataDepth(this.ipsData.type_Donnee.type, this.ipsData.identifier, params, true).pipe(
        map(res => {
          const typeData = (this.isPiezo) ? "depth" : "debit";
          if (res.length > 1) {
            const lastDate = (res[0].length > 0) ? res[0].at(-1) : {date:null,value:0};
            const firstDate = (res.length > 1 && res[1].length > 0) ? res[1][0] : {date:null,value:0};
            if (isSameDay(lastDate.date,firstDate.date)) {
              res[1].shift(); //enleve la premiere date du temps reel si identique aux donnees
            }
            const concatArray = [...res[0], ... res[1]];
            this.showDepthChart = concatArray.length > 0 && concatArray.every((data: { altitudeRepere: undefined; }) => data.altitudeRepere !== undefined);
            this.hasDetails = concatArray.length > 0;
            const result = {
              typeData: typeData,
              result: concatArray
            };
            return result;
          }
          const result = {
            typeData: typeData,
            result: res
          };
          return result;
        }
          
        ),
        catchError((error) => {
          console.error('Error fetching sensor data depth:', error);
          this.showDepthChart = false;
          return of({ typeData: "depth", result: [] } as ChartData);
        })
      );
    }
  }

  onHide(){
    this.sidebarService.setSidebarStatus(false);
  }

  get headerBackgroundColor() {
    const color = this.ipsData?.couleur || '#FFFFFF';
    return this.hexToRgba(color, 1);
  }

  get getBackgroundWithOpacity(){
    const color = this.ipsData?.couleur || '#FFFFFF';
    return this.hexToRgba(color, 0.5);
  }

  private hexToRgba(hex: string, alpha: number): string {
    let c: any;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + `,${alpha})`;
    }
    throw new Error('Bad Hex');
  }

  get iconClass(): any {
    switch (this.ipsData?.tendance) {
      case 'baisse':
        return faArrowDown;
      case 'hausse':
        return faArrowUp;
      case 'stable':
        return faEquals;
      default:
        return faQuestion; 
    }
  }

  get textColor(): string {
    const classToColorMap: { [key: string]: string } = {
      'très haut': 'white',
      'haut': 'white',
      'modérément haut': 'black',
      'moyen': 'black',
      'modérément bas': 'black',
      'bas': 'black',
      'très bas': 'black'
    };
    return classToColorMap[this.ipsData.libelleClasse.toLowerCase()] || 'black';
  }

  openDepthInfoModal() {
    this.showDepthModal = true;
  }

  hideDepthInfoModal() {
    this.showDepthModal = false;
  }

  openModeleInfoModal() {
    this.showModeleModal = true;
  }

  hideModeleInfoModal() {
    this.showModeleModal = false;
  }

  showDetails() {
    this.showDepthDetail = !this.showDepthDetail;
  }
  
}
